// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","break":"App_break__1vXpd"};